import clsx from 'clsx'

import mainStyles from 'assets/css/main.module.scss'
import { ReactComponent as ChevronRight } from 'assets/icons/chevron-right.svg'
import BottomArc from 'components/bottomArc/BottomArc'
import { Button } from 'components/common/button/Button'
import { FrameworkWheelPage } from 'components/interactiveNavigation/FrameworkWheel'
import KeyTasks from 'components/keyTasks/KeyTasks'
import PageBanner from 'components/pageBanner/PageBanner'
import { ReturnToLandingButton } from 'components/returnToLandingButton/ReturnToLandingButton'
import { TopReturnToLandingButton } from 'components/topReturnToLandingButton/TopReturnToLandingButton'
import useHardNavigate from 'hooks/useHardNavigate'
import { AnalyticsActionType } from 'types/common/analytics.type'
import { EVENTS, trackAnalytics } from 'utils/analytics'

import styles from './Produce.module.scss'

const Produce = () => {
  const hardNavigate = useHardNavigate()

  return (
    <div className={styles.Produce}>
      <TopReturnToLandingButton />

      <PageBanner
        heading="Produce"
        description="Let’s build, build, build. Visuals, video, translations, and anything else we need to make this experience a success, everywhere.  "
        showBubble
        bubbleText="The makers are busy making"
        backgroundStyle={{ background: 'linear-gradient(180deg, #ABE3B7 0%, #71D085 100%)' }}
        showNavigationCircle
        bigTextFillColor="#71D085"
        page={FrameworkWheelPage.Produce}
      />
      <KeyTasks
        tasks={[
          {
            title: 'Align on production',
            description:
              'Connect with your OU or Global Production Lead to assign the right work to the relevant team.',
            backgroundColor: '#E4F6E8',
          },
          {
            title: 'Develop, adapt, and finalize all assets',
            description: 'And don’t forget to get local clearance as needed. ',
            backgroundColor: '#E4F6E8',
          },
          {
            title: 'Upload on KO assets',
            description: 'Upload on KO assets and distribute to everyone.',
            backgroundColor: '#E4F6E8',
          },
          {
            title: 'Go live!',
            description: 'And capture any learnings done in-flight.',
            backgroundColor: '#E4F6E8',
          },
        ]}
        inputs={[{ text: 'Market activation plans' }, { text: 'Content plans' }]}
        outputs={[
          { text: 'Final assets approved and uploaded on KO assets' },
          { text: 'Live execution' },
          {
            text: 'Reflections and improvements on ways of working',
            link: 'https://app.mural.co/t/marketing6265/m/marketing6265/1747976237864/f1cf546811959a5c0c18fc38ec66fbdef1cdaf45',
          },
        ]}
        color="green"
      />

      <div className={clsx(mainStyles.container)}>
        <div className="flex justify-center">
          <Button
            variant="navigationControlBlack"
            text="Go to Shape"
            iconLeft={<ChevronRight className="rotate-180" />}
            border
            className="mr-4"
            onClick={() => {
              hardNavigate(FrameworkWheelPage.Shape)
              trackAnalytics({
                type: AnalyticsActionType.action,
                payload: EVENTS.ACTION.PRODUCE.TO_SHAPE,
              })
            }}
          />
          <ReturnToLandingButton />
          <Button
            variant="navigationControlBlack"
            text="Go to Learn"
            iconRight={<ChevronRight />}
            border
            className="ml-4"
            onClick={() => {
              hardNavigate(FrameworkWheelPage.Learn)
              trackAnalytics({
                type: AnalyticsActionType.action,
                payload: EVENTS.ACTION.PRODUCE.TO_LEARN,
              })
            }}
          />
        </div>
      </div>
      <BottomArc backgroundColor="white" />
    </div>
  )
}

export default Produce
